function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.75 10.0625C19.75 9.84375 19.5312 9.625 19.3125 9.625H14.0625C13.8164 9.625 13.625 9.84375 13.625 10.0625V10.9375C13.625 11.1836 13.8164 11.375 14.0625 11.375H15.3203L13.1328 20.125H11.4375C11.1914 20.125 11 20.3438 11 20.5625V21.4375C11 21.6836 11.1914 21.875 11.4375 21.875H16.6875C16.9062 21.875 17.125 21.6836 17.125 21.4375V20.5625C17.125 20.3438 16.9062 20.125 16.6875 20.125H15.4023L17.5898 11.375H19.3125C19.5312 11.375 19.75 11.1836 19.75 10.9375V10.0625Z",
  fill: "#D5D7DE"
});

var SvgItalic = function SvgItalic(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItalic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/italic.f382a9f4.svg";
export { ForwardRef as ReactComponent };